import { WWW_AUDIENCE_FILTER } from '@pkg/config/sanity/audience';
import { LOCALISE_LANGUAGE_FIELD_NAME, PARENT_FIELD } from '@pkg/config/sanity/constants';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { DOCUMENT_SLUG_PREFIX } from '@pkg/config/sanity/schemaConfig';
import { buildPageBySlugQuery } from '@pkg/sanity-utils/queries/pageBySlug';
import { pageFields, shallowPageFields } from '~/apis/sanity/queries/partials/pageFields';

/**
 * B2B acquisition pages render on apps/business, including untagged legacy documents.
 */
const wwwPageAudienceFilter =
  `(${WWW_AUDIENCE_FILTER}) && !(_type in ["${DOCUMENT.ACQUISITION_B2B_PAGES}", "${DOCUMENT.INITIATIVE_B2B_PAGES}"])`;

export const pageBySlug = (path?: any) => buildPageBySlugQuery(path, {
  audienceFilter: wwwPageAudienceFilter,
  pageFields,
});

/**
 * The query to give to the Listener when in Draft Mode, for pageBySlug.
 * This is because pageBySlug query is too large to listen to, so we must use a stripped back version.
 */
const type = `!(_type in [${Object.keys(DOCUMENT_SLUG_PREFIX).map(type => `"${type}"`).join(', ')}])`;
const locale = `${LOCALISE_LANGUAGE_FIELD_NAME} == $locale`;
const slug = 'slug.current == $slug';
const parent = `(!defined($parent) || ${PARENT_FIELD}->slug.current == $parent)`;
const grandParent = `(!defined($grandParent) || ${PARENT_FIELD}->${PARENT_FIELD}->slug.current == $grandParent)`;
const greatGrandParent = `(!defined($greatGrandParent) || ${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}->slug.current == $greatGrandParent)`;
const audience = wwwPageAudienceFilter;

const pageSelector = groq`"page": *[${type} && ${locale} && ${slug} && ${audience} && ${parent} && ${grandParent} && ${greatGrandParent}][0]`;

export const pageBySlugListener = groq`{
  ${pageSelector} {
    ${shallowPageFields}
  }
}`;
